<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_intro')
}

const isOnResourcesSection = computed(() => {
  return route.path.startsWith('/resources')
})

const goToResources = () => {
  router.push('/resources')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        Welcome! I'm your resource advisor.
      </p>
      <p class="pb-2">
        Resources are mined from your planets and converted by refineries into materials.
      </p>
      <p class="pb-2">
        Some materials let you build large projects like terraforming, ringworlds and more.
      </p>
      <p class="pb-2">
        Lets go over to the resources section!
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Resources" button in the top menu.
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Resources".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResourcesSection" @click="goToResources" class="mr-2">
        Go to Resources
      </ActionButton>
      <ActionButton @click="handleNextStep">
        I'm there!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>